var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header",class:_vm.align},[(_vm.badge)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.badge))]):_vm._e(),(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),(_vm.showRedLine)?_c('div',{staticClass:"red-line"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }